import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { splitVoce, VoceLink, linkUsabile } from "@/components/NovitaVoce";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles, Check, Loader2 } from "lucide-react";

const fmt = (d) => { try { return new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }); } catch { return d; } };

const Nota = ({ n, puo, onOpen }) => (
  <section className="py-4 first:pt-0 border-b border-border last:border-0" data-testid={`novita-nota-${n.id}`}>
    <h3 className="font-heading text-base text-navy">Versione {n.versione}</h3>
    <p className="text-xs text-slate-500 mb-2">Aggiornamento n. {n.rev ?? "—"} del {fmt(n.data)}{n.titolo ? ` · ${n.titolo}` : ""}</p>
    <ul className="space-y-2 text-sm text-slate-700">
      {n.voci.map((v, i) => {
        const { testo, link } = splitVoce(v);
        return (
          <li key={i} className="flex items-start gap-2"><Check className="h-4 w-4 mt-0.5 shrink-0 text-[#0E8C84]" />
            <span className="flex-1">{testo}</span>
            {puo(link) && <VoceLink link={link} onOpen={onOpen} testid={`novita-apri-${n.id}-${i}`} />}
          </li>
        );
      })}
    </ul>
  </section>
);

export const NovitaDialog = () => {
  const [note, setNote] = useState([]);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { user, apps } = useAuth();

  useEffect(() => {
    api.get("/novita/da-leggere").then(({ data }) => setNote(data.note || [])).catch(() => setNote([]));
  }, []);

  if (!note.length) return null;

  const conferma = async () => {
    setBusy(true);
    try { await api.post("/novita/presa-visione", { ids: note.map((n) => n.id) }); setNote([]); return true; }
    catch { return false; }
    finally { setBusy(false); }
  };
  const apri = async (link) => { await conferma(); if (link !== window.location.pathname) navigate(link); };
  const ultima = note[0];

  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="max-w-2xl [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()} data-testid="novita-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading text-navy">
            <span className="h-9 w-9 rounded-full bg-[#0E8C84]/10 flex items-center justify-center"><Sparkles className="h-5 w-5 text-[#0E8C84]" /></span>
            {note.length === 1 ? `Novità della versione ${ultima.versione}` : `Novità: ${note.length} versioni da leggere`}
          </DialogTitle>
          <DialogDescription data-testid="novita-versione">
            Versione attuale {ultima.versione} · Aggiornamento n. {ultima.rev ?? "—"} del {fmt(ultima.data)}
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[55vh] overflow-y-auto pr-1" data-testid="novita-voci">
          {note.map((n) => <Nota key={n.id} n={n} onOpen={apri} puo={(l) => linkUsabile(user, apps, l)} />)}
        </div>
        <DialogFooter className="items-center gap-2 sm:justify-between">
          <span className="text-xs text-slate-500">Un solo clic conferma la presa visione di tutte le versioni elencate.</span>
          <Button onClick={conferma} disabled={busy} data-testid="novita-ok-btn">{busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}OK, presa visione</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
